import { Team } from '@ori/testid-generator';

export const APP_NAME = 'novage-skincare-advisor';
export const APP_TEAM_NAME: Team = Team.Presentation;
export const NOT_LOGGED_IN_USER_ID = -1;
export const OPEN_HREF_ATTRIBUTE = `#open-${APP_NAME}`;
export const OPEN_QUERY_PARAM = 'openNovageSkincareAdvisor';
export const OPEN_QUERY_PARAM_ALWAYS = 'always';
export const OPEN_QUERY_PARAM_ONCE = 'once';
export const OPEN_QUERY_PARAM_VALID_VALUES = [OPEN_QUERY_PARAM_ALWAYS, OPEN_QUERY_PARAM_ONCE];
export const OPTANON_CONSENT_COOKIE = 'OptanonConsent';
export const ONE_TRUST_GROUP_PERFORMANCE = 'C0002';
export const REVIEVE_USER_ID_COOKIE = 'revieve-userid';
export const ROOT_ELEMENT_ID = `${APP_NAME}-root`;
